import { render, staticRenderFns } from "./BAutocompleteTopic.vue?vue&type=template&id=da9c7b80&"
import script from "./BAutocompleteTopic.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports